// src/components/hr/LeaveManagement/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Tabs,
  Tab,
  Card,
  CardContent,
  Button,
  styled,
  useTheme,
  Paper,
  Badge,
  CircularProgress
} from '@mui/material';
import {
  People as PeopleIcon,
  EventNote as EventNoteIcon,
  Assessment as AssessmentIcon,
  Settings as SettingsIcon,
  Notifications as NotificationsIcon
} from '@mui/icons-material';


import {LeaveRequests} from './LeaveRequests';
import LeaveTypes from './LeaveTypes';
import LeavePolicies from './LeavePolicies';
import HolidayCalendar from './HolidayCalendar';
import LeaveBalances from './LeaveBalances';
import LeaveHistory from './LeaveHistory';
import EmployeeLeaveManagement from '../../../Employee/Leaves/EmployeeLeaveManagement';
// import LeaveReports from './LeaveReports';
// import ApplyLeave from '../leavebal';
// import LeaveManagementDashboard from '../leavehistoryhr';

const StyledCard = styled(Card)(({ theme }) => ({
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  borderRadius: 16,
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
  },
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: 12,
  fontWeight: 600,
  padding: '10px 16px',
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  marginBottom: theme.spacing(3),
  padding: '6px',
  '& .MuiTabs-indicator': {
    height: 0,
  },
  '& .MuiTab-root': {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'none',
    minHeight: 48,
    borderRadius: 8,
    margin: '0 4px',
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light + '20',
    },
  },
}));

const ContentPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 16,
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
  backgroundColor: theme.palette.background.paper,
  minHeight: 'calc(100vh - 280px)',
}));

const SummaryCard = styled(StyledCard)(({ theme, color }) => ({
  backgroundColor: color,
  color: 'white',
  '& .MuiTypography-root': {
    color: 'white',
  },
}));

const HRLeaveDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [summaryData, setSummaryData] = useState({
    pendingRequests: 0,
    lowBalanceAlerts: 0,
    totalEmployees: 0,
    leaveTypes: 0,
    loading: true
  });
  const theme = useTheme();

  useEffect(() => {
    
    const fetchDashboardData = async () => {
      
      setTimeout(() => {
        setSummaryData({
          pendingRequests: 12,
          lowBalanceAlerts: 5,
          totalEmployees: 120,
          leaveTypes: 8,
          loading: false
        });
      }, 1000);
    };

    fetchDashboardData();
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        padding: theme.spacing(4),
        backgroundColor: theme.palette.grey[50],
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      

     
      <StyledTabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab icon={<EventNoteIcon />} label="Leave Requests" />
        <Tab icon={<PeopleIcon />} label="Leave Balances" />
        <Tab icon={<AssessmentIcon />} label=" Employees Leave History" />
        <Tab icon={<EventNoteIcon />} label="Holiday Calendar" />
        {/* <Tab icon={<AssessmentIcon />}label="Apply Leave" />
        <Tab icon={<SettingsIcon />} label="My Leave Usage" /> */}
        <Tab icon={<SettingsIcon />} label="Leave Types" />
         {/* <Tab icon={<SettingsIcon />} label="Leave Policies" /> */}
        <Tab icon={<AssessmentIcon />} label="My Leaves" /> 
      </StyledTabs>
      <ContentPaper>
        {activeTab === 0 && <LeaveRequests />}
        {activeTab === 1 && <LeaveBalances />}
        {activeTab === 2 && <LeaveHistory />}
        {activeTab === 3 && <HolidayCalendar />}
      
        {/* {activeTab ===5 && <div>
            <h2 style={{ color: '#FF8C00', marginBottom: '20px' }}>My Leave Usage</h2>
            <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
              <div style={{ 
                flex: 1, 
                backgroundColor: '#f8f8f8', 
                padding: '20px', 
                borderRadius: '8px',
                border: '1px solid #e0e0e0'
              }}>
                <h3 style={{ marginBottom: '15px', color: '#333' }}>Leave Balance</h3>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                  <span>Sick Leave:</span>
                  <span style={{ fontWeight: '500' }}>8.0 days</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                  <span>Vacation:</span>
                  <span style={{ fontWeight: '500' }}>15.0 days</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>Personal Leave:</span>
                  <span style={{ fontWeight: '500' }}>3.0 days</span>
                </div>
              </div>
              
              <div style={{ 
                flex: 1, 
                backgroundColor: '#f8f8f8', 
                padding: '20px', 
                borderRadius: '8px',
                border: '1px solid #e0e0e0'
              }}>
                <h3 style={{ marginBottom: '15px', color: '#333' }}>Leave Used (2023)</h3>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                    <span>Sick Leave:</span>
                  <span style={{ fontWeight: '500' }}>2.0 days</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                  <span>Vacation:</span>
                  <span style={{ fontWeight: '500' }}>5.0 days</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>Personal Leave:</span>
                  <span style={{ fontWeight: '500' }}>1.0 days</span>
                </div>
              </div>
            </div>
            
            <h3 style={{ marginBottom: '15px', color: '#333' }}>Leave History</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f8f8', textAlign: 'left' }}>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Date</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Leave Type</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Duration</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Status</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Comments</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>2023-10-15 to 2023-10-20</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Vacation - US</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>5.00 day(s)</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Approved</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Family vacation</td>
                </tr>
                <tr>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>2023-07-05 to 2023-07-06</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Sick Leave - US</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>2.00 day(s)</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Approved</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Doctor's appointment</td>
                </tr>
                <tr>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>2023-03-15</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Personal Leave</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>1.00 day(s)</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Approved</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Personal matters</td>
                </tr>
              </tbody>
            </table>
          </div>} */}
        
         {activeTab ===4 && <LeaveTypes/>}
         {activeTab ===5 && <EmployeeLeaveManagement />}
      </ContentPaper>
    </Box>
  );
};

export default HRLeaveDashboard;


// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   Button,
//   Tabs,
//   Tab,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   Avatar,
//   Badge,
//   IconButton,
//   TextField,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   CircularProgress,
//   LinearProgress,
//   Tooltip,
//   Divider,
//   alpha,
//   useTheme
// } from '@mui/material';

// import {
//   Dashboard as DashboardIcon,
//   EventNote as EventNoteIcon,
//   People as PeopleIcon,
//   Assessment as AssessmentIcon,
//   Settings as SettingsIcon,
//   Notifications as NotificationsIcon,
//   Search as SearchIcon,
//   Add as AddIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   Info as InfoIcon,
//   FilterList as FilterListIcon,
//   ArrowBack as ArrowBackIcon,
//   DateRange as DateRangeIcon,
//   Person as PersonIcon,
//   Business as BusinessIcon,
//   Comment as CommentIcon,
//   ArrowForward as ArrowForwardIcon,
//   Visibility as VisibilityIcon,
//   Print as PrintIcon,
//   FileDownload as FileDownloadIcon
// } from '@mui/icons-material';

// // Mock data for leave requests
// const initialRequests = [
//   { id: 1, employeeName: 'John Doe', employeeId: 'EMP001', department: 'Engineering', leaveType: 'Earned Leave', fromDate: '2023-07-10', toDate: '2023-07-15', days: 5, reason: 'Family vacation', status: 'Pending', appliedOn: '2023-06-25', avatar: 'JD' },
//   { id: 2, employeeName: 'Jane Smith', employeeId: 'EMP015', department: 'Marketing', leaveType: 'Sick Leave', fromDate: '2023-07-05', toDate: '2023-07-06', days: 2, reason: 'Not feeling well', status: 'Pending', appliedOn: '2023-07-04', avatar: 'JS' },
//   { id: 3, employeeName: 'Robert Johnson', employeeId: 'EMP042', department: 'Finance', leaveType: 'Casual Leave', fromDate: '2023-07-20', toDate: '2023-07-20', days: 1, reason: 'Personal work', status: 'Approved', appliedOn: '2023-07-01', avatar: 'RJ' },
//   { id: 4, employeeName: 'Emily Davis', employeeId: 'EMP078', department: 'HR', leaveType: 'Maternity Leave', fromDate: '2023-08-01', toDate: '2023-11-01', days: 90, reason: 'Maternity leave', status: 'Pending', appliedOn: '2023-06-15', avatar: 'ED' },
//   { id: 5, employeeName: 'Michael Brown', employeeId: 'EMP101', department: 'Sales', leaveType: 'Earned Leave', fromDate: '2023-07-12', toDate: '2023-07-14', days: 3, reason: 'Client meeting', status: 'Approved', appliedOn: '2023-07-01', avatar: 'MB' },
//   { id: 6, employeeName: 'Linda Wilson', employeeId: 'EMP112', department: 'Engineering', leaveType: 'Sick Leave', fromDate: '2023-07-25', toDate: '2023-07-25', days: 1, reason: 'Headache', status: 'Rejected', appliedOn: '2023-07-24', avatar: 'LW' },
// ];

// // Mock data for employee leave balances
// const initialEmployees = [
//   {
//     id: 1,
//     name: 'John Doe',
//     employeeId: 'EMP001',
//     department: 'Engineering',
//     avatar: 'JD',
//     leaveBalances: [
//       { type: 'Earned Leave', total: 15, used: 5, pending: 2, remaining: 8 },
//       { type: 'Sick Leave', total: 12, used: 3, pending: 0, remaining: 9 },
//       { type: 'Casual Leave', total: 10, used: 8, pending: 0, remaining: 2 }
//     ]
//   },
//   {
//     id: 2,
//     name: 'Jane Smith',
//     employeeId: 'EMP015',
//     department: 'Marketing',
//     avatar: 'JS',
//     leaveBalances: [
//       { type: 'Earned Leave', total: 15, used: 2, pending: 5, remaining: 8 },
//       { type: 'Sick Leave', total: 12, used: 0, pending: 2, remaining: 10 },
//       { type: 'Casual Leave', total: 10, used: 4, pending: 0, remaining: 6 }
//     ]
//   },
//   {
//     id: 3,
//     name: 'Robert Johnson',
//     employeeId: 'EMP042',
//     department: 'Finance',
//     avatar: 'RJ',
//     leaveBalances: [
//       { type: 'Earned Leave', total: 15, used: 15, pending: 0, remaining: 0 },
//       { type: 'Sick Leave', total: 12, used: 5, pending: 0, remaining: 7 },
//       { type: 'Casual Leave', total: 10, used: 6, pending: 2, remaining: 2 }
//     ]
//   }
// ];

// // Leave type colors
// const leaveTypeColors = {
//   'Earned Leave': '#4caf50',
//   'Sick Leave': '#f44336',
//   'Casual Leave': '#2196f3',
//   'Maternity Leave': '#9c27b0',
//   'Paternity Leave': '#673ab7',
// };

// // Status colors and icons
// const statusConfig = {
//   'Approved': { 
//     color: '#4caf50', 
//     bgColor: '#e8f5e9',
//     icon: <CheckCircleIcon fontSize="small" />
//   },
//   'Rejected': { 
//     color: '#f44336', 
//     bgColor: '#ffebee',
//     icon: <CancelIcon fontSize="small" />
//   },
//   'Pending': { 
//     color: '#ff9800', 
//     bgColor: '#fff3e0',
//     icon: <InfoIcon fontSize="small" />
//   }
// };

// const HRLeaveDashboard = () => {
//   const theme = useTheme();
//   const [activeTab, setActiveTab] = useState(0);
//   const [requests, setRequests] = useState(initialRequests);
//   const [employees, setEmployees] = useState(initialEmployees);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [detailsOpen, setDetailsOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [summaryData, setSummaryData] = useState({
//     pendingRequests: 0,
//     lowBalanceAlerts: 0,
//     totalEmployees: 0,
//     leaveTypes: 0,
//     loading: true
//   });

//   // Calculate summary data
//   useEffect(() => {
//     // Simulate fetching dashboard data
//     const fetchDashboardData = async () => {
//       setLoading(true);
//       // In a real app, this would be an API call
//       setTimeout(() => {
//         const pendingCount = requests.filter(req => req.status === 'Pending').length;
//         const lowBalanceCount = employees.reduce((count, emp) => {
//           const hasLowBalance = emp.leaveBalances.some(balance => balance.remaining <= 2);
//           return hasLowBalance ? count + 1 : count;
//         }, 0);
        
//         setSummaryData({
//           pendingRequests: pendingCount,
//           lowBalanceAlerts: lowBalanceCount,
//           totalEmployees: employees.length,
//           leaveTypes: 5,
//           loading: false
//         });
//         setLoading(false);
//       }, 1000);
//     };

//     fetchDashboardData();
//   }, [requests, employees]);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   const handleSearch = (event) => {
//     setSearchTerm(event.target.value);
//   };

//   const handleApprove = (id) => {
//     setRequests(requests.map(req =>
//       req.id === id ? { ...req, status: 'Approved' } : req
//     ));
//   };

//   const handleReject = (id) => {
//     setRequests(requests.map(req =>
//       req.id === id ? { ...req, status: 'Rejected' } : req
//     ));
//   };

//   const handleViewDetails = (request) => {
//     setSelectedRequest(request);
//     setDetailsOpen(true);
//   };

//   const filteredRequests = requests.filter(request =>
//     request.employeeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     request.employeeId.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     request.leaveType.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     request.status.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const getStatusChip = (status) => {
//     const config = statusConfig[status] || { 
//       color: theme.palette.grey[700], 
//       bgColor: theme.palette.grey[200],
//       icon: null
//     };
    
//     return (
//       <Chip 
//         size="small" 
//         label={status} 
//         icon={config.icon}
//         sx={{ 
//           color: config.color,
//           bgcolor: config.bgColor,
//           fontWeight: 500,
//           '& .MuiChip-label': { px: 1 },
//           '& .MuiChip-icon': { color: 'inherit' }
//         }}
//       />
//     );
//   };

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'short', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString('en-US', options);
//   };

//   // Leave Requests Component
//   const LeaveRequestsTab = () => (
//     <Box>
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center', 
//         mb: 3
//       }}>
//         <Typography variant="h6" sx={{ fontWeight: 600, color: '#334155' }}>
//           Leave Requests
//         </Typography>
//         <Box sx={{ display: 'flex', gap: 2 }}>
//           <TextField
//             placeholder="Search requests..."
//             size="small"
//             value={searchTerm}
//             onChange={handleSearch}
//             InputProps={{
//               startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
//               sx: { borderRadius: '12px' }
//             }}
//           />
//           <Button 
//             variant="outlined" 
//             startIcon={<FilterListIcon />}
//             sx={{ 
//               borderRadius: '12px', 
//               textTransform: 'none',
//               fontWeight: 500
//             }}
//           >
//             Filters
//           </Button>
//         </Box>
//       </Box>

//       <Card elevation={0} sx={{ borderRadius: 2, overflow: 'hidden', border: '1px solid #eaecef' }}>
//         <TableContainer>
//           <Table>
//             <TableHead sx={{ backgroundColor: '#f5f7fa' }}>
//               <TableRow>
//                 <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Employee</TableCell>
//                 <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Department</TableCell>
//                 <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Leave Type</TableCell>
//                 <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Duration</TableCell>
//                 <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Days</TableCell>
//                 <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Status</TableCell>
//                 <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredRequests.map((request) => (
//                 <TableRow
//                   key={request.id}
//                   hover
//                   sx={{
//                     '&:hover': {
//                       backgroundColor: '#f5f9ff'
//                     },
//                     transition: 'background-color 0.2s'
//                   }}
//                 >
//                   <TableCell>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                       <Avatar
//                         sx={{
//                           bgcolor: leaveTypeColors[request.leaveType] || '#9e9e9e',
//                           width: 36,
//                           height: 36,
//                           fontSize: '0.9rem'
//                         }}
//                       >
//                         {request.avatar}
//                       </Avatar>
//                       <Box>
//                         <Typography sx={{ fontWeight: 500, color: '#37474f' }}>{request.employeeName}</Typography>
//                         <Typography variant="caption" sx={{ color: '#78909c' }}>{request.employeeId}</Typography>
//                       </Box>
//                     </Box>
//                   </TableCell>
//                   <TableCell>
//                     <Typography sx={{ color: '#455a64' }}>{request.department}</Typography>
//                   </TableCell>
//                   <TableCell>
//                     <Chip
//                       label={request.leaveType}
//                       size="small"
//                       sx={{
//                         backgroundColor: `${leaveTypeColors[request.leaveType]}15`,
//                         color: leaveTypeColors[request.leaveType],
//                         fontWeight: 500,
//                         borderRadius: 1,
//                         '& .MuiChip-label': { px: 1 }
//                       }}
//                     />
//                   </TableCell>
//                   <TableCell>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                       <DateRangeIcon fontSize="small" sx={{ color: '#9e9e9e', mr: 0.5 }} />
//                       <Box>
//                         <Typography variant="body2" sx={{ color: '#455a64' }}>
//                           {formatDate(request.fromDate)}
//                         </Typography>
//                         <Typography variant="caption" sx={{ color: '#78909c' }}>
//                           to {formatDate(request.toDate)}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </TableCell>
//                   <TableCell>
//                     <Typography
//                       sx={{
//                         fontWeight: 600,
//                         color: request.days > 5 ? '#f57c00' : '#455a64'
//                       }}
//                     >
//                       {request.days}
//                     </Typography>
//                   </TableCell>
//                   <TableCell>
//                     {getStatusChip(request.status)}
//                   </TableCell>
//                   <TableCell>
//                                         <Box sx={{ display: 'flex', gap: 1 }}>
//                       <Tooltip title="Approve">
//                         <span>
//                           <IconButton
//                             size="small"
//                             color="success"
//                             onClick={() => handleApprove(request.id)}
//                             disabled={request.status === 'Approved' || request.status === 'Rejected'}
//                             sx={{
//                               bgcolor: request.status === 'Pending' ? 'success.light' : 'transparent',
//                               color: request.status === 'Pending' ? 'white' : undefined,
//                               '&:hover': { bgcolor: 'success.main', color: 'white' },
//                               transition: 'all 0.2s'
//                             }}
//                           >
//                             <CheckCircleIcon fontSize="small" />
//                           </IconButton>
//                         </span>
//                       </Tooltip>
//                       <Tooltip title="Reject">
//                         <span>
//                           <IconButton
//                             size="small"
//                             color="error"
//                             onClick={() => handleReject(request.id)}
//                             disabled={request.status === 'Approved' || request.status === 'Rejected'}
//                             sx={{
//                               bgcolor: request.status === 'Pending' ? 'error.light' : 'transparent',
//                               color: request.status === 'Pending' ? 'white' : undefined,
//                               '&:hover': { bgcolor: 'error.main', color: 'white' },
//                               transition: 'all 0.2s'
//                             }}
//                           >
//                             <CancelIcon fontSize="small" />
//                           </IconButton>
//                         </span>
//                       </Tooltip>
//                       <Tooltip title="View Details">
//                         <IconButton
//                           size="small"
//                           color="primary"
//                           onClick={() => handleViewDetails(request)}
//                           sx={{
//                             bgcolor: 'primary.light',
//                             color: 'white',
//                             '&:hover': { bgcolor: 'primary.main' },
//                             transition: 'all 0.2s'
//                           }}
//                         >
//                           <InfoIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               ))}
//               {filteredRequests.length === 0 && (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
//                     <Typography variant="body1" color="textSecondary">
//                       No leave requests found matching your search.
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Card>

//       {/* Leave Request Details Dialog */}
//       <Dialog
//         open={detailsOpen}
//         onClose={() => setDetailsOpen(false)}
//         maxWidth="md"
//         PaperProps={{
//           sx: {
//             borderRadius: 2,
//             overflow: 'hidden'
//           }
//         }}
//       >
//         {selectedRequest && (
//           <>
//             <DialogTitle sx={{
//               bgcolor: 'primary.main',
//               color: 'white',
//               display: 'flex',
//               alignItems: 'center',
//               gap: 1
//             }}>
//               <IconButton
//                 size="small"
//                 onClick={() => setDetailsOpen(false)}
//                 sx={{ color: 'white', mr: 1 }}
//               >
//                 <ArrowBackIcon />
//               </IconButton>
//               Leave Request Details
//             </DialogTitle>
//             <DialogContent sx={{ pt: 3, px: 4 }}>
//               <Box sx={{ display: 'flex', mb: 3, alignItems: 'center', gap: 2 }}>
//                 <Avatar
//                   sx={{
//                     bgcolor: leaveTypeColors[selectedRequest.leaveType] || '#9e9e9e',
//                     width: 56,
//                     height: 56,
//                     fontSize: '1.2rem'
//                   }}
//                 >
//                   {selectedRequest.avatar}
//                 </Avatar>
//                 <Box>
//                   <Typography variant="h6" sx={{ fontWeight: 600, color: '#37474f' }}>
//                     {selectedRequest.employeeName}
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: '#78909c' }}>
//                     {selectedRequest.employeeId} • {selectedRequest.department}
//                   </Typography>
//                 </Box>
//                 <Chip
//                   label={selectedRequest.status}
//                   sx={{
//                     ml: 'auto',
//                     backgroundColor: `${statusConfig[selectedRequest.status]?.bgColor || '#e0e0e0'}`,
//                     color: statusConfig[selectedRequest.status]?.color || '#616161',
//                     fontWeight: 500,
//                     borderRadius: 1,
//                     '& .MuiChip-label': { px: 2 }
//                   }}
//                 />
//               </Box>
//               <Divider sx={{ my: 2 }} />
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <Card variant="outlined" sx={{ height: '100%', borderRadius: 2, borderColor: '#e0e0e0' }}>
//                     <CardContent>
//                       <Typography variant="subtitle2" sx={{ color: '#78909c', mb: 1 }}>
//                         Leave Information
//                       </Typography>
//                       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                         <Box sx={{ width: '40%' }}>
//                           <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
//                             Leave Type
//                           </Typography>
//                         </Box>
//                         <Box sx={{ width: '60%' }}>
//                           <Chip
//                             label={selectedRequest.leaveType}
//                             size="small"
//                             sx={{
//                               backgroundColor: `${leaveTypeColors[selectedRequest.leaveType]}15`,
//                               color: leaveTypeColors[selectedRequest.leaveType],
//                               fontWeight: 500,
//                               borderRadius: 1,
//                               '& .MuiChip-label': { px: 1 }
//                             }}
//                           />
//                         </Box>
//                       </Box>
//                       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                         <Box sx={{ width: '40%' }}>
//                           <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
//                             From Date
//                           </Typography>
//                         </Box>
//                         <Box sx={{ width: '60%' }}>
//                           <Typography variant="body2" sx={{ color: '#37474f' }}>
//                             {formatDate(selectedRequest.fromDate)}
//                           </Typography>
//                         </Box>
//                       </Box>
//                       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                         <Box sx={{ width: '40%' }}>
//                           <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
//                             To Date
//                           </Typography>
//                         </Box>
//                         <Box sx={{ width: '60%' }}>
//                           <Typography variant="body2" sx={{ color: '#37474f' }}>
//                             {formatDate(selectedRequest.toDate)}
//                           </Typography>
//                         </Box>
//                       </Box>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Box sx={{ width: '40%' }}>
//                           <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
//                             Duration
//                           </Typography>
//                         </Box>
//                         <Box sx={{ width: '60%' }}>
//                           <Typography variant="body2" sx={{
//                             color: '#37474f',
//                             fontWeight: 600,
//                             bgcolor: '#f5f5f5',
//                             px: 1.5,
//                             py: 0.5,
//                             borderRadius: 1,
//                             display: 'inline-block'
//                           }}>
//                             {selectedRequest.days} day{selectedRequest.days > 1 ? 's' : ''}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Card variant="outlined" sx={{ height: '100%', borderRadius: 2, borderColor: '#e0e0e0' }}>
//                     <CardContent>
//                       <Typography variant="subtitle2" sx={{ color: '#78909c', mb: 1 }}>
//                         Request Information
//                       </Typography>
//                       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                         <Box sx={{ width: '40%' }}>
//                           <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
//                             Applied On
//                           </Typography>
//                         </Box>
//                         <Box sx={{ width: '60%' }}>
//                           <Typography variant="body2" sx={{ color: '#37474f' }}>
//                             {formatDate(selectedRequest.appliedOn)}
//                           </Typography>
//                         </Box>
//                       </Box>
//                       <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
//                         <Box sx={{ width: '40%', pt: 0.5 }}>
//                           <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
//                             Status
//                           </Typography>
//                         </Box>
//                         <Box sx={{ width: '60%' }}>
//                           {getStatusChip(selectedRequest.status)}
//                         </Box>
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Card variant="outlined" sx={{ borderRadius: 2, borderColor: '#e0e0e0' }}>
//                     <CardContent>
//                       <Typography variant="subtitle2" sx={{ color: '#78909c', mb: 2 }}>
//                         Reason for Leave
//                       </Typography>
//                       <Paper
//                         variant="outlined"
//                         sx={{
//                           p: 2,
//                           bgcolor: '#f8f9fa',
//                           borderColor: '#e0e0e0',
//                           borderRadius: 2
//                         }}
//                       >
//                         <Typography variant="body2" sx={{ color: '#37474f', lineHeight: 1.6 }}>
//                           {selectedRequest.reason}
//                         </Typography>
//                       </Paper>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               </Grid>
//             </DialogContent>
//             <DialogActions sx={{ p: 3, bgcolor: '#f5f7fa', borderTop: '1px solid #e0e0e0' }}>
//               {selectedRequest.status === 'Pending' && (
//                 <>
//                   <Button
//                     variant="contained"
//                     color="success"
//                     onClick={() => {
//                       handleApprove(selectedRequest.id);
//                       setDetailsOpen(false);
//                     }}
//                     startIcon={<CheckCircleIcon />}
//                     sx={{
//                       borderRadius: 2,
//                       textTransform: 'none',
//                       px: 3,
//                       boxShadow: 2
//                     }}
//                   >
//                     Approve Request
//                   </Button>
//                   <Button
//                     variant="contained"
//                     color="error"
//                     onClick={() => {
//                       handleReject(selectedRequest.id);
//                       setDetailsOpen(false);
//                     }}
//                     startIcon={<CancelIcon />}
//                     sx={{
//                       borderRadius: 2,
//                       textTransform: 'none',
//                       px: 3,
//                       boxShadow: 2
//                     }}
//                   >
//                     Reject Request
//                   </Button>
//                 </>
//               )}
//               <Button
//                 onClick={() => setDetailsOpen(false)}
//                 variant="outlined"
//                 sx={{
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   color: '#546e7a',
//                   borderColor: '#cfd8dc',
//                   '&:hover': {
//                     borderColor: '#b0bec5',
//                     bgcolor: '#f5f5f5'
//                   }
//                 }}
//               >
//                 Close
//               </Button>
//             </DialogActions>
//           </>
//         )}
//       </Dialog>
//     </Box>
//   );

//   // Leave Balances Tab
//   const LeaveBalancesTab = () => {
//     const getProgressColor = (remaining, total) => {
//       const percentage = (remaining / total) * 100;
//       if (percentage <= 20) return theme.palette.error.main;
//       if (percentage <= 40) return theme.palette.warning.main;
//       return theme.palette.success.main;
//     };

//     return (
//       <Box>
//         <Box sx={{ 
//           display: 'flex', 
//           justifyContent: 'space-between', 
//           alignItems: 'center', 
//           mb: 3
//         }}>
//           <Typography variant="h6" sx={{ fontWeight: 600, color: '#334155' }}>
//             Employee Leave Balances
//           </Typography>
//           <TextField
//             variant="outlined"
//             size="small"
//             placeholder="Search employee..."
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon color="action" />
//                 </InputAdornment>
//               ),
//               sx: { borderRadius: 2 }
//             }}
//             sx={{ width: 250 }}
//           />
//         </Box>

//         <Card elevation={0} sx={{ borderRadius: 2, overflow: 'hidden', border: '1px solid #eaecef' }}>
//           <TableContainer>
//             <Table>
//               <TableHead sx={{ backgroundColor: '#f5f7fa' }}>
//                 <TableRow>
//                   <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Employee</TableCell>
//                   <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Department</TableCell>
//                   <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Leave Type</TableCell>
//                   <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Total</TableCell>
//                   <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Used</TableCell>
//                   <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Pending</TableCell>
//                   <TableCell sx={{ fontWeight: 600, color: '#546e7a' }}>Remaining</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {employees.map(employee => (
//                   employee.leaveBalances.map((balance, index) => (
//                     <TableRow
//                       key={`${employee.id}-${balance.type}`}
//                       hover
//                       sx={{
//                         '&:hover': {
//                           backgroundColor: '#f5f9ff'
//                         },
//                         transition: 'background-color 0.2s'
//                       }}
//                     >
//                       {index === 0 && (
//                         <>
//                           <TableCell
//                             rowSpan={employee.leaveBalances.length}
//                             sx={{ borderLeft: `4px solid ${theme.palette.primary.main}` }}
//                           >
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                               <Avatar
//                                 sx={{                                  bgcolor: theme.palette.primary.main,
//                                   width: 36,
//                                   height: 36,
//                                   fontSize: '0.9rem'
//                                 }}
//                               >
//                                 {employee.avatar}
//                               </Avatar>
//                               <Box>
//                                 <Typography sx={{ fontWeight: 500, color: '#37474f' }}>
//                                   {employee.name}
//                                 </Typography>
//                                 <Typography variant="caption" sx={{ color: '#78909c' }}>
//                                   {employee.employeeId}
//                                 </Typography>
//                               </Box>
//                             </Box>
//                           </TableCell>
//                           <TableCell rowSpan={employee.leaveBalances.length}>
//                             <Chip
//                               label={employee.department}
//                               size="small"
//                               icon={<BusinessIcon fontSize="small" />}
//                               sx={{
//                                 backgroundColor: alpha(theme.palette.primary.main, 0.1),
//                                 color: theme.palette.primary.dark,
//                                 fontWeight: 500,
//                                 borderRadius: 1,
//                                 '& .MuiChip-label': { px: 1 }
//                               }}
//                             />
//                           </TableCell>
//                         </>
//                       )}
//                       <TableCell>
//                         <Chip
//                           label={balance.type}
//                           size="small"
//                           sx={{
//                             backgroundColor: `${leaveTypeColors[balance.type] || theme.palette.grey[500]}15`,
//                             color: leaveTypeColors[balance.type] || theme.palette.grey[700],
//                             fontWeight: 500,
//                             borderRadius: 1,
//                             '& .MuiChip-label': { px: 1 }
//                           }}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <Typography sx={{ fontWeight: 500, color: '#455a64' }}>
//                           {balance.total}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Typography sx={{ color: '#455a64' }}>
//                           {balance.used}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         {balance.pending > 0 ? (
//                           <Chip
//                             label={balance.pending}
//                             size="small"
//                             sx={{
//                               backgroundColor: alpha(theme.palette.warning.main, 0.1),
//                               color: theme.palette.warning.dark,
//                               fontWeight: 500,
//                               borderRadius: 8,
//                               minWidth: 30,
//                               height: 24
//                             }}
//                           />
//                         ) : (
//                           <Typography sx={{ color: '#455a64' }}>
//                             {balance.pending}
//                           </Typography>
//                         )}
//                       </TableCell>
//                       <TableCell>
//                         <Box sx={{ width: '100%', maxWidth: 150 }}>
//                           <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
//                             <Typography
//                               variant="body2"
//                               sx={{
//                                 fontWeight: 600,
//                                 color: balance.remaining <= 2 ? theme.palette.error.main :
//                                   balance.remaining <= 5 ? theme.palette.warning.main :
//                                     theme.palette.success.main,
//                                 mr: 1
//                               }}
//                             >
//                               {balance.remaining}
//                             </Typography>
//                             {balance.remaining <= 2 && (
//                               <Tooltip title="Low balance">
//                                 <InfoIcon fontSize="small" sx={{ color: theme.palette.warning.main }} />
//                               </Tooltip>
//                             )}
//                           </Box>
//                           <LinearProgress
//                             variant="determinate"
//                             value={(balance.remaining / balance.total) * 100}
//                             sx={{
//                               height: 6,
//                               borderRadius: 3,
//                               backgroundColor: alpha(theme.palette.grey[500], 0.2),
//                               '& .MuiLinearProgress-bar': {
//                                 backgroundColor: getProgressColor(balance.remaining, balance.total),
//                                 borderRadius: 3
//                               }
//                             }}
//                           />
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Card>
//       </Box>
//     );
//   };

//   // Render the main dashboard
//   return (
//     <Box sx={{
//       padding: theme.spacing(4),
//       backgroundColor: theme.palette.grey[50],
//       minHeight: '100vh',
//       display: 'flex',
//       flexDirection: 'column',
//     }}>
//       <Box
//         sx={{
//           background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
//           borderRadius: '16px',
//           padding: '24px',
//           color: 'white',
//           marginBottom: '24px',
//           boxShadow: '0 10px 25px rgba(59, 130, 246, 0.2)'
//         }}
//       >
//         <Typography variant="h4" fontWeight="700">HR Leave Management</Typography>
//         <Typography variant="body1" sx={{ opacity: 0.9, mt: 1 }}>
//           Manage employee leave requests efficiently
//         </Typography>
//       </Box>

//       {/* Summary Cards */}
//       <Grid container spacing={3} sx={{ mb: theme.spacing(4) }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ 
//             height: '100%', 
//             borderRadius: 4, 
//             background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
//             color: 'white',
//             boxShadow: '0 8px 16px rgba(25, 118, 210, 0.2)'
//           }}>
//             <CardContent>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
//                 <Typography variant="h6" fontWeight="600">
//                   Pending Requests
//                 </Typography>
//                 <Badge badgeContent={summaryData.pendingRequests} color="error" sx={{ '& .MuiBadge-badge': { fontSize: 12, height: 20, minWidth: 20 } }}>
//                   <EventNoteIcon fontSize="large" />
//                 </Badge>
//               </Box>
//               {loading ? (
//                 <CircularProgress size={40} sx={{ color: 'white', opacity: 0.8 }} />
//               ) : (
//                 <>
//                   <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
//                     {summaryData.pendingRequests}
//                   </Typography>
//                   <Button
//                     variant="contained"
//                     size="small"
//                     sx={{ bgcolor: 'rgba(255,255,255,0.2)', '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' } }}
//                     onClick={() => setActiveTab(0)}
//                   >
//                     View All
//                   </Button>
//                 </>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ 
//             height: '100%', 
//             borderRadius: 4, 
//             background: 'linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)',
//             color: 'white',
//             boxShadow: '0 8px 16px rgba(255, 152, 0, 0.2)'
//           }}>
//             <CardContent>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
//                 <Typography variant="h6" fontWeight="600">
//                   Low Balance Alerts
//                 </Typography>
//                 <NotificationsIcon fontSize="large" />
//               </Box>
//               {loading ? (
//                 <CircularProgress size={40} sx={{ color: 'white', opacity: 0.8 }} />
//               ) : (
//                 <>
//                   <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
//                     {summaryData.lowBalanceAlerts}
//                   </Typography>
//                   <Button
//                     variant="contained"
//                     size="small"
//                     sx={{ bgcolor: 'rgba(255,255,255,0.2)', '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' } }}
//                     onClick={() => setActiveTab(1)}
//                   >
//                     Review
//                   </Button>
//                 </>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ 
//             height: '100%', 
//             borderRadius: 4, 
//             background: 'linear-gradient(135deg, #4caf50 0%, #81c784 100%)',
//             color: 'white',
//             boxShadow: '0 8px 16px rgba(76, 175, 80, 0.2)'
//           }}>
//             <CardContent>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
//                 <Typography variant="h6" fontWeight="600">
//                   Total Employees
//                 </Typography>
//                 <PeopleIcon fontSize="large" />
//               </Box>
//               {loading ? (
//                 <CircularProgress size={40} sx={{ color: 'white', opacity: 0.8 }} />
//               ) : (
//                 <>
//                   <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
//                     {summaryData.totalEmployees}
//                   </Typography>
//                   <Button
//                     variant="contained"
//                     size="small"
//                     sx={{ bgcolor: 'rgba(255,255,255,0.2)', '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' } }}
//                   >
//                     Details
//                   </Button>
//                 </>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ 
//             height: '100%', 
//             borderRadius: 4, 
//             background: 'linear-gradient(135deg, #9c27b0 0%, #ba68c8 100%)',
//             color: 'white',
//             boxShadow: '0 8px 16px rgba(156, 39, 176, 0.2)'
//           }}>
//             <CardContent>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
//                 <Typography variant="h6" fontWeight="600">
//                   Leave Types
//                 </Typography>
//                 <SettingsIcon fontSize="large" />
//               </Box>
//               {loading ? (
//                 <CircularProgress size={40} sx={{ color: 'white', opacity: 0.8 }} />
//               ) : (
//                 <>
//                   <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
//                     {summaryData.leaveTypes}
//                   </Typography>
//                   <Button
//                     variant="contained"
//                     size="small"
//                     sx={{ bgcolor: 'rgba(255,255,255,0.2)', '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' } }}
//                   >
//                     Configure
//                   </Button>
//                 </>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Main Tabs */}
//       <Paper sx={{ 
//         borderRadius: 3, 
//         boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)', 
//         overflow: 'hidden',
//         flexGrow: 1,
//         display: 'flex',
//         flexDirection: 'column'
//       }}>
//         <Tabs
//           value={activeTab}
//           onChange={handleTabChange}
//           variant="scrollable"
//           scrollButtons="auto"
//           sx={{
//             px: 2,
//             pt: 2,
//             borderBottom: 1,
//             borderColor: 'divider',
//             '& .MuiTab-root': {
//               minHeight: 48,
//               borderRadius: '8px 8px 0 0',
//               mr: 1,
//               fontWeight: 600,
//               textTransform: 'none',
//               '&.Mui-selected': {
//                 color: theme.palette.primary.main,
//                 backgroundColor: alpha(theme.palette.primary.main, 0.05)
//               }
//             }
//           }}
//         >
//           <Tab icon={<EventNoteIcon sx={{ mr: 1 }} />} label="Leave Requests" iconPosition="start" />
//           <Tab icon={<PeopleIcon sx={{ mr: 1 }} />} label="Leave Balances" iconPosition="start" />
//           <Tab icon={<AssessmentIcon />} label="Leave History" iconPosition='start'/>
//           <Tab icon={<SettingsIcon />} label="Leave Types" iconPosition='start' />
// //         <Tab icon={<SettingsIcon />} label="Leave Policies" iconPosition='start'/>
// //         <Tab icon={<EventNoteIcon />} label="Holiday Calendar"iconPosition='start' />
//           <Tab icon={<AssessmentIcon sx={{ mr: 1 }} />} label="Reports" iconPosition="start" />
//           <Tab icon={<SettingsIcon sx={{ mr: 1 }} />} label="Settings" iconPosition="start" />
//         </Tabs>
//         <Box sx={{ p: 3, flexGrow: 1, bgcolor: alpha(theme.palette.background.paper, 0.8) }}>
//           {activeTab === 0 && <LeaveRequestsTab />}
//           {activeTab === 1 && <LeaveBalancesTab />}
//           {activeTab === 2}
//           {activeTab === 2 && (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//               <Typography variant="h6" color="textSecondary">Reports Module Coming Soon</Typography>
//             </Box>
//           )}
//           {activeTab === 3 && (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//               <Typography variant="h6" color="textSecondary">Settings Module Coming Soon</Typography>
//             </Box>
//           )}
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default HRLeaveDashboard;
                                  